import type {SxProps, Theme} from '@mui/material';
import {Grid} from '@mui/material';
import type {ReactNode} from 'react';

type Props = {
    children : ReactNode;
    sx ?: SxProps<Theme>;
};

const ContainerCenteredGrid = ({children, sx = []} : Props) : JSX.Element => {
    const newSx : SxProps<Theme> = Array.isArray(sx) ? sx : [sx];

    return <Grid
        sx={[
            {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
            },
            ...newSx,
        ]}
    >
        {children}
    </Grid>;
};

export default ContainerCenteredGrid;
